/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/ismp.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import { getListOfObjects } from 'views/pages/admin/audit-log/service';

const IsmpRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        ISMP_Purpose: oldRecord.Purpose,
        Purpose: null,
    };
    const refactoredNewRecord = {
        ...newRecord,
        ISMP_Purpose: newRecord.Purpose,
        Purpose: null,
    };
    const listOfObjects = ['MonitoringStrategy', 'ISMP_Purpose', 'Scope'];

    const items =
        getListOfObjects(refactoredOldRecord, refactoredNewRecord, oldItem, newItem, 'ISMP_Summary', listOfObjects) ??
        [];

    return <FieldChangeGrid items={items} />;
};

export { IsmpRecordChangeGrid };
